import React from 'react'
import "../style/header_style.css"

export default function Header() {
  return (
    <div className='header'>OverLoad</div>
  )
}
